import breakpoints from './breakpoints';

const isMobile = (breakpoint = 'l') => {
  return window.innerWidth < breakpoints[breakpoint];
};

export default isMobile;
